__turbopack_context__.v({
  "button": "TemplateStartButton-module-scss-module__m5RmZa__button",
  "enter": "TemplateStartButton-module-scss-module__m5RmZa__enter",
  "exit": "TemplateStartButton-module-scss-module__m5RmZa__exit",
  "fade-in": "TemplateStartButton-module-scss-module__m5RmZa__fade-in",
  "fade-out": "TemplateStartButton-module-scss-module__m5RmZa__fade-out",
  "fade-out-80": "TemplateStartButton-module-scss-module__m5RmZa__fade-out-80",
  "slide-in-from-bottom": "TemplateStartButton-module-scss-module__m5RmZa__slide-in-from-bottom",
  "slide-in-from-left": "TemplateStartButton-module-scss-module__m5RmZa__slide-in-from-left",
  "slide-in-from-right": "TemplateStartButton-module-scss-module__m5RmZa__slide-in-from-right",
  "slide-in-from-top": "TemplateStartButton-module-scss-module__m5RmZa__slide-in-from-top",
  "slide-out-to-bottom": "TemplateStartButton-module-scss-module__m5RmZa__slide-out-to-bottom",
  "slide-out-to-left": "TemplateStartButton-module-scss-module__m5RmZa__slide-out-to-left",
  "slide-out-to-right": "TemplateStartButton-module-scss-module__m5RmZa__slide-out-to-right",
  "slide-out-to-top": "TemplateStartButton-module-scss-module__m5RmZa__slide-out-to-top",
  "zoom-in": "TemplateStartButton-module-scss-module__m5RmZa__zoom-in",
  "zoom-out": "TemplateStartButton-module-scss-module__m5RmZa__zoom-out",
});
